<template lang="pug">
#loading-screen
  .overlay
  .image-container
    .loading-image
</template>

<script>
export default {}
</script>

<style lang="sass">
#loading-screen
  position: fixed
  height: 100vh
  width: 100vw
  left: 0
  top: 0
  z-index: 1000
  .overlay
    width: 100%
    height: 100%
    background-color: dimgray
    animation-name: loading-overlay
    animation-duration: 3s
    animation-fill-mode: forwards
  .image-container
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    opacity: 0
    animation-name: loading-start
    animation-duration: 3s
    animation-fill-mode: forwards
    .loading-image
      background-image: url('../assets/images/loading/load-1.png')
      animation-name: loading-frames
      animation-duration: 1.2s
      animation-iteration-count: infinite
      animation-timing-function: linear
      background-size: 100%
      width: 319px
      height: 54px

@keyframes loading-overlay
  0%
    opacity: 0
  100%
    opacity: 0.2

@keyframes loading-start
  0%
    opacity: 0
  100%
    opacity: 1

@keyframes loading-frames
  0%
    background-image: url('../assets/images/loading/load-1.png')
  16.5%
    background-image: url('../assets/images/loading/load-2.png')
  33%
    background-image: url('../assets/images/loading/load-3.png')
  49.5%
    background-image: url('../assets/images/loading/load-4.png')
  66%
    background-image: url('../assets/images/loading/load-5.png')
  82.5%
    background-image: url('../assets/images/loading/load-6.png')
  100%
    background-image: url('../assets/images/loading/load-1.png')
</style>
